import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import GUI from 'lil-gui'


/**
 * Base
 */
// Debug
const gui = new GUI()

// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()

/**
 * Galaxy
 */

const parameters = {};
parameters.count = 30000;
parameters.size = 0.02
parameters.radius = 5;
parameters.branches = 3;
parameters.spin = 1;
parameters.randomness = 0.2;
parameters.randomPower = 3;
parameters.insideColor = '#ff6030';
parameters.outsideColor = '#1b3984';

let geometry = null;
let points = null;
let material = null;

const galaxyGenerator = () =>{

    if(points!=null){
        geometry.dispose()
        material.dispose();
        scene.remove(points);
    }

    geometry = new THREE.BufferGeometry();
    const positions = new Float32Array(parameters.count * 3);
    const colors = new Float32Array(parameters.count * 3);

    for(let i=0; i<parameters.count; i++){
        const i3 = i * 3;
        const radius = Math.random() * parameters.radius;
        const spin = radius * parameters.spin;
        const branchAngles = (i % parameters.branches) / parameters.branches * Math.PI * 2;

        const colorInside = new THREE.Color(parameters.insideColor);
        const colorOutside = new THREE.Color(parameters.outsideColor);

        const randomX = Math.pow(Math.random(), parameters.randomPower) * (Math.random() < 0.5 ? -1 : 1)
        const randomY = Math.pow(Math.random(), parameters.randomPower) * (Math.random() < 0.5 ? -1 : 1)
        const randomZ = Math.pow(Math.random(), parameters.randomPower) * (Math.random() < 0.5 ? -1 : 1)


        positions[i3] = Math.sin(branchAngles + spin) * radius + randomX;
        positions[i3 + 1] = randomY / 2;
        positions[i3 + 2] = Math.cos(branchAngles + spin) * radius + randomZ;

        const mixedColor = colorInside.clone();
        mixedColor.lerp(colorOutside, radius / parameters.radius)

        colors[i3] = mixedColor.r;
        colors[i3 + 1] = mixedColor.g;
        colors[i3 + 2] = mixedColor.b;

    }

    geometry.setAttribute('position', new THREE.BufferAttribute(positions, 3));

    geometry.setAttribute('color', new THREE.BufferAttribute(colors, 3));
    
    material = new THREE.PointsMaterial({
        size: parameters.size,
        sizeAttenuation: true,
        blending: THREE.AdditiveBlending,
        depthWrite: false,
        vertexColors: true

    })

    points = new THREE.Points(geometry, material);
    scene.add(points);
}
galaxyGenerator();

gui.add(parameters, 'count').min(100).max(100000).step(100).onFinishChange(galaxyGenerator);
gui.add(parameters, 'size').min(0.01).max(0.1).step(0.01).onFinishChange(galaxyGenerator);
gui.add(parameters, 'radius').min(0.01).max(20).step(0.01).onFinishChange(galaxyGenerator);
gui.add(parameters, 'branches').min(2).max(20).step(1).onFinishChange(galaxyGenerator);
gui.add(parameters, 'spin').min(-5).max(5).step(0.01).onFinishChange(galaxyGenerator);
gui.add(parameters, 'randomness').min(0).max(2).step(0.001).onFinishChange(galaxyGenerator);
gui.add(parameters, 'randomPower').min(1).max(10).step(0.001).onFinishChange(galaxyGenerator);
gui.addColor({color: parameters.insideColor},'color').onChange((value) =>{
    parameters.insideColor = value;
}).onFinishChange(galaxyGenerator);
gui.addColor({color: parameters.outsideColor}, 'color').onChange((value)=>{
    parameters,outsideColor = value;
}).onFinishChange(galaxyGenerator);



/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 100)
camera.position.x = 3
camera.position.y = 3
camera.position.z = 3
scene.add(camera)

// Controls
const controls = new OrbitControls(camera, canvas)
controls.enableDamping = true

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

/**
 * Animate
 */
const clock = new THREE.Clock()

const tick = () =>
{
    const elapsedTime = clock.getElapsedTime()

    

    // Update controls
    controls.update()

    // Render
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()